import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Bentley_Bentayga_EWB_Mulliner_ from '../asset/Bentley_Bentayga_EWB_Mulliner_.jpg';
import Continental_GT from '../asset/Continental_GT.jpg'
import Flying_spur_azure from '../asset/Flying_spur_azure.jpg'
import BOE_1 from '../asset/BOE_1.jpg'
import About from './about';

export default function Home() {
  return (
    <>
        <Carousel data-bs-theme="light" >
        <Carousel.Item>
            <img
            className="d-block w-100"
            src={Bentley_Bentayga_EWB_Mulliner_}
            alt="First slide"
            />
            <Carousel.Caption>
            <h5>BENTAYGA EXTENDED WHEELBASE MULLINER</h5>
            <p>The Bentayga Extended Wheelbase Mulliner is the pinnacle of Bentley and a breathtaking new benchmark for SUV luxury and wellbeing. With a powerful V8 engine, the latest technology and incredible dynamic handling, it delivers everything the Mulliner name stands for in terms of prestige, presence and personalisation.</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
            className="d-block w-100"
            src={Continental_GT}
            alt="Second slide"
            />
            <Carousel.Caption>
            <h5>CONTINENTAL GT SPEED</h5>
            <p>With a phenomenal 6.0 litre, twin-turbocharged W12 petrol engine, the Bentley Continental GT Speed delivers truly unrivalled power alongside supreme sporting style..</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
            className="d-block w-100"
            src={Flying_spur_azure}
            alt="Third slide"
            />
            <Carousel.Caption>
            <h5>FLYING SPUR AZURE</h5>
            <p>
            The Flying Spur Azure is a luxury sedan offering unrivalled comfort and elegance. Available as a 4.0 litre V8 or a 2.9 litre V6 luxury hybrid, it is truly effortless to drive
            </p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img
            className="d-block w-100"
            src={BOE_1}
            alt="Third slide"
            />
            <Carousel.Caption>
            <h5>BENTAYGA ODYSSEAN EDITION</h5>
            <p>
            A stunning limited edition, the Bentayga Odyssean Edition combines an advanced 3.0 litre V6 hybrid engine with exclusively curated styling and sustainable materials.
            </p>
            </Carousel.Caption>
        </Carousel.Item>
        </Carousel>
        <About/>
    </>
  )
}
